import { Capacitor } from "@capacitor/core";

function isSafari() {
  const userAgent = navigator.userAgent;
  const isChrome = userAgent.indexOf("Chrome") > -1;
  const isSafari = userAgent.indexOf("Safari") > -1;

  // Chrome has both 'Chrome' and 'Safari' in its user agent string.
  // Safari has only 'Safari'.
  if (isChrome && isSafari) return false;
  else if (isSafari) return true;

  return false;
}

function isChrome() {
  const userAgent = navigator.userAgent;
  const isChrome = userAgent.indexOf("Chrome") > -1;
  const isChromium = userAgent.indexOf("Chromium") > -1;
  const isEdge = userAgent.indexOf("Edg") > -1; // 'Edg' is used for the Chromium-based Edge.
  const isOpera = userAgent.indexOf("OPR") > -1;

  // Chrome's user agent contains "Chrome", but so do Edge and Opera's.
  // We need to exclude them from the check.
  if (isChrome && !isEdge && !isOpera && !isChromium) return true;

  return false;
}

function isChromium() {
  const userAgent = navigator.userAgent;
  return userAgent.includes("Chrome") || userAgent.includes("Chromium");
}

export const PLATFORM = Capacitor.getPlatform();
export const IS_SAFARI = isSafari();
export const IS_CHROME = isChrome();
export const IS_CHROMIUM = isChromium();
export const IS_WEB = PLATFORM == "web";
export const IS_IOS = PLATFORM == "ios";
export const IS_TOP = window.self === window.top;
export const LOOSE_LIFE_RECOVERY_TIME = __DEV__ ? 5 * 60 : 20 * 60;
export const RUN_EFFECTS_PARALLEL = true;
export const MIN_ASPECT_RATIO = 2;
export const BOARD_ASPECT_RATIO = 4 / 3;
export const SET_CELL_SHADOW = false;
export const ENABLE_SHAKING = true;
export const BOOSTER_IAP_ENABLED = true;
export const TRANSLATE_ENABLED = false;
export const ACHIEVEMENTS_ENABLED = false;
export const NUM_LIVES_EARN = 3;
export const NUM_LIVES_WAIT = 3;
export const NUM_LIVES_INVITE_FRIEND_INVITER = 5;
export const NUM_LIVES_INVITE_FRIEND_INVITEE = 3;
export const RECORD = true;
export const RECOR_FRAME_RATE = 1;
export const DEFAULT_ERROR_SNACK_SHOW = __DEV__;
export const FUNCTIONS_ENDPOINT =
  __DEV__ && IS_WEB
    ? "http://localhost:5001/chat-noir-hexagon/us-central1/"
    : "https://{function-name}-h4h6bme23a-uc.a.run.app/";
// export const FUNCTIONS_ENDPOINT =
//   "https://convert-svgs-to-video-h4h6bme23a-uc.a.run.app/";

export const NODE_FUNCTIONS_ENDPOINT =
  __DEV__ && IS_WEB
    ? "http://localhost:5001/chat-noir-hexagon/us-central1/"
    : "https://us-central1-chat-noir-hexagon.cloudfunctions.net/";

class Config {
  async initialize() {
    const { App } = await import("./plugins");
    if (IS_WEB) {
      this.VERSION = __CONFIG__.versionName;
      return;
    }
    const { name, id, build, version } = await App.getInfo();
    this.APP_NAME = name;
    this.ID = id;
    this.BUILD = build;
    this.VERSION = version;
  }
}

const config = new Config();
if (__DEV__) window.config = config;
export default config;
